import {styled} from "@mui/material";

export const SliderContainer = styled('div')({
  marginLeft: 5,
  marginBottom: 25,
});
